import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { type CompanyInfo } from "@vega-core/models/companyInfo";

export const useAuthCompanyInfo = (): CompanyInfo => {
  const {
    global: { companyName },
    contacts: { helpEmail },
    theme: { logos },
  } = usePublicConfig();

  return {
    logoDark: logos.logoDark,
    logoLight: logos.logoLight,
    smallLogoDark: logos.smallLogoDark,
    smallLogoLight: logos.smallLogoLight,
    name: companyName,
    helpEmail: helpEmail,
  } as CompanyInfo;
};
